// Govern the search popup
(function($){
	$('.search-open a').click(function(e) {
		$('#search-form').addClass('open');
		$('#search-form').removeClass('close');

		$('#header-search-input').focus();
	});

	$('#search-close').click(function(e) {
		$('#search-form').removeClass('open');
		$('#search-form').addClass('close');

		$('#header-search-input').val('').blur();
	});
})(jQuery);